import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=7336c7c7&functional=true&"
import script from "./PageTabs.vue?vue&type=script&lang=js&"
export * from "./PageTabs.vue?vue&type=script&lang=js&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=7336c7c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports